import { MaterialIcons } from "@expo/vector-icons";
import { useRoute } from "@react-navigation/core";
import * as Application from "expo-application";
import * as LocalAuthentication from "expo-local-authentication";
import * as SecureStore from "expo-secure-store";
import {
	Box,
	Button,
	FormControl,
	Icon,
	Input,
	ScrollView,
	Stack,
	Text,
	useMediaQuery,
	useTheme,
	useToast,
} from "native-base";
import React, { useEffect, useState } from "react";
import { Alert, Image, Platform, SafeAreaView, View } from "react-native";
import { useDispatch } from "react-redux";
import login from "../../common/login";
import ContentArea from "../../components/ContentArea";
import ErrorToast from "../../components/ErrorToast";
import { setAuth } from "../../redux/slices/LoginSlice";
import Constants from "../../utils/Constants";
import { setWithExpiry } from "../../utils/LocalStorageManipulation";
import { getBrandLoginImage, isWeb } from "../../utils/utils";
import ForgotPassword from "./ForgotPassword";
import { useIsFocused } from "@react-navigation/native";
import InfoToast from "../../components/InfoToast";

const Login = ({ components, navigation, route }) => {
	const isFocused = useIsFocused();
	const isDesktopOrLaptop = useMediaQuery({ minWidth: 960 });
	const [isLogin, setIsLogin] = useState(true);
	const [isLogginIn, setIsLogginIn] = useState(false);
	const [credentials, setCredentials] = useState({
		// Username: "27847005021",
		// Password: "1H1k3tHeM@gal1esb3rg_",
		// Username: "27800005201",
		// Password: "P@55w0rd",
		Username: "",
		Password: "",
	});
	const [isVisible, setIsVisible] = useState(false);
	const [biometricStatus, setbiometricStatus] = useState({
		deviceStatus: false,
		isEnrolled: false,
		credentials: null,
	});
	const toast = useToast();

	const supportedAuthenticationTypes = Object.freeze({
		1: "FINGERPRINT",
		2: "FACIAL_RECOGNITION",
		3: "IRIS",
	});

	const dispatch = useDispatch();
	const { colors } = useTheme();

	useEffect(() => {
		setIsLogin(true);
		if (Platform.OS !== "web" && isFocused) {
			getEnrollmentLevel();
		}
	}, [route]);

	const getEnrollmentLevel = async () => {
		let deviceStatus = await LocalAuthentication.hasHardwareAsync();
		let enrollmentLevel = await LocalAuthentication.getEnrolledLevelAsync();
		let isEnrolled = await LocalAuthentication.isEnrolledAsync();
		let supportedAuthenticationTypes =
			await LocalAuthentication.supportedAuthenticationTypesAsync();

		let credentials = await SecureStore.getItemAsync("credentials");

		setbiometricStatus({ deviceStatus, isEnrolled, credentials });

		if (credentials) {
			let auth = await Authenticate(isEnrolled, deviceStatus);

			if (auth.success) {
				try {
					let user = await login(JSON.parse(credentials));

					dispatch(setAuth(user.data));
					setIsLogginIn(false);
				} catch (error) {
					setIsLogginIn(false);
					if (error.data?.error) {
						ErrorToast(error.data.error, "Login");
						await SecureStore.deleteItemAsync("credentials");
						setbiometricStatus({ ...biometricStatus, credentials: null });
					} else {
						ErrorToast(error.message, "Login");
					}
				}
			}

			// else {
			// 	InfoToast("Authentication cancelled");
			// }
		}
	};

	const Authenticate = async (isEnrolled, deviceStatus) => {
		if (deviceStatus === true) {
			let authenticate = await LocalAuthentication.authenticateAsync({
				promptMessage: "Sign In",
			});

			return authenticate;
		} else {
			return false;
		}
	};

	const handleLogin = async () => {
		try {
			setIsLogginIn(true);
			let user = await login(credentials);
			if (user.data.result) {
				// AsyncStorage.setItem("auth",JSON.stringify(user.data) );
				setWithExpiry(
					"auth",
					JSON.stringify(user.data),
					Constants.SessionDuration
				);
				if (
					biometricStatus.isEnrolled === true &&
					!biometricStatus.credentials
				) {
					Alert.alert(
						`Do you want to allow ${Application.applicationName} to use biometric authentication?`,
						"This app was designed to support biometric authentication",
						[
							{
								text: "Don't Allow",
								onPress: async () => {
									setIsLogginIn(false);
									dispatch(setAuth(user.data));
								},
								style: "cancel",
							},
							{
								text: "OK",
								onPress: async () => {
									SecureStore.setItemAsync(
										"credentials",
										JSON.stringify(credentials)
									);
									setIsLogginIn(false);
									dispatch(setAuth(user.data));
								},
							},
						]
					);
				} else if (
					biometricStatus.deviceStatus === true &&
					biometricStatus.isEnrolled === false
				) {
					Alert.alert(
						`Do you want to allow ${Application.applicationName} to use biometric authentication?`,
						"This app was designed to support biometric authentication, please enroll to use this feature",
						[
							{
								text: "OK",
								onPress: async () => {
									setIsLogginIn(false);
									dispatch(setAuth(user.data));
								},
							},
						]
					);
				} else {
					if (Platform.OS !== "web")
						SecureStore.setItemAsync(
							"credentials",
							JSON.stringify(credentials)
						);

					setIsLogginIn(false);
					dispatch(setAuth(user.data));
				}
			}
		} catch (error) {
			setIsLogginIn(false);

			// if (!toast.isActive("error")) return;

			if (error.data?.error) {
				ErrorToast(error.data.error, "Login");
			} else {
				ErrorToast(error.message, "Login");
			}
		}
	};

	return (
		<SafeAreaView style={{ flex: 1 }}>
			{isLogin && Platform.OS !== "web" && (
				<Box marginTop={20}>
					<View>
						<Image
							resizeMode="contain"
							source={{
								uri: isWeb()
									? getBrandLoginImage()
									: Image.resolveAssetSource(getBrandLoginImage()).uri,
							}}
							style={{
								width: 350,
								height: 180,
								alignSelf: "center",
								// backgroundColor: "pink",
							}}
						/>
						{/* <Heading
							size="lg"
							alignSelf="center"
							style={{ top: -35, fontWeight: "500" }}
						>
							Welcome!
						</Heading>
						<Heading
							size="sm"
							alignSelf="center"
							style={{ top: -35, fontWeight: "300" }}
						>
							Please sign in to continue
						</Heading> */}
					</View>
				</Box>
			)}
			<ContentArea>
				<FormControl isRequired>
					<Stack
						mx="3"
						space={3}
						marginLeft={isDesktopOrLaptop[0] ? "auto" : 0}
						marginRight={isDesktopOrLaptop[0] ? "auto" : 0}
						width={isDesktopOrLaptop[0] ? "450" : null}
						padding={isDesktopOrLaptop[0] ? "10" : null}
					>
						{isLogin && (
							<View
								style={{
									flex: 1,
									flexDirection: "row",
									height: 30,
									alignItems: "center",
									borderBottomColor: "#d5d5d5",
									borderBottomWidth: 1,
									marginBottom: 10,
								}}
							>
								<View
									style={{
										backgroundColor: colors.primary["500"],
										width: 10,
										height: "100%",
									}}
								/>
								<Text style={{ fontSize: 16, fontWeight: "600" }}>
									{" "}
									Sign In
								</Text>
							</View>
						)}
						{isLogin ? (
							<Stack space={4}>
								{components?.children_components.map((control, index) => {
									switch (control.componenttype_name) {
										case "INPUT":
											let controlType = "text";
											if (
												control.datatype_label?.toLowerCase().includes("email")
											) {
												controlType = "email";
											} else if (
												control.datatype_label
													?.toLowerCase()
													.includes("password")
											) {
												controlType = "password";
											}
											return (
												<View key={control.sitepagecomponent_guid}>
													<Input
														testID={control.sitepagecomponent_meta?.id}
														variant="underlined"
														padding={3}
														key={index}
														onChangeText={(value) =>
															setCredentials({
																...credentials,
																[control.datatype_label]: value,
															})
														}
														secureTextEntry={
															controlType == "password" && !isVisible
																? true
																: false
														}
														placeholder={`${
															control.sitepagecomponent_meta.altLabel
																? control.sitepagecomponent_meta.altLabel
																: control.datatype_label
														}`}
														label={`${
															control.sitepagecomponent_meta.altLabel
																? control.sitepagecomponent_meta.altLabel
																: control.datatype_label
														}`}
														value={credentials[control.datatype_label]}
														InputLeftElement={
															<Icon
																as={
																	<MaterialIcons
																		name={
																			controlType == "password"
																				? "lock"
																				: "phone"
																		}
																	/>
																}
																size={5}
																ml="2"
																color="muted.400"
															/>
														}
														InputRightElement={
															controlType == "password" ? (
																<Icon
																	onPress={() => setIsVisible(!isVisible)}
																	as={
																		<MaterialIcons
																			name={
																				isVisible
																					? "visibility"
																					: "visibility-off"
																			}
																		/>
																	}
																	size={5}
																	mr="2"
																	color="muted.400"
																/>
															) : null
														}
													/>
												</View>
											);
										case "BUTTON":
											return (
												<Button
													testID="sign-in"
													key={control.sitepagecomponent_guid}
													isLoading={isLogginIn}
													isLoadingText="Logging In"
													variant={isLogginIn ? "outline" : "solid"}
													onPress={() => handleLogin()}
												>
													Sign In
												</Button>
											);
									}
								})}
								<Button
									padding={0}
									variant="link"
									onPress={() => setIsLogin(false)}
								>
									Forgot password?
								</Button>

								<Button
									padding={0}
									variant="link"
									onPress={() => navigation.navigate("Member Registration")}
								>
									Create account
								</Button>
							</Stack>
						) : (
							<ScrollView>
								<ForgotPassword setIsLogin={setIsLogin} />
							</ScrollView>
						)}
					</Stack>
				</FormControl>
			</ContentArea>
		</SafeAreaView>
	);
};

export default Login;
